export const MenuWithNotificationIcon: React.FC<
  React.SVGProps<SVGSVGElement>
> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <path
        d="M0.833984 10H11.6673"
        strokeWidth="1.66667"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M1 4H11"
        strokeWidth="1.66667"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M0.833984 15.8333H19.1673"
        strokeWidth="1.66667"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};
